const { get, put } = require('actions/api');
import { GET_CALCULATION_PROFILE, PUT_CALCULATION_PROFILE } from 'constants/actionTypes';
import type { CalculationSettings } from 'reducers/dashboard';

export const getCalculationProfile = () =>
  get(GET_CALCULATION_PROFILE, 'api', '/calculations/v1/profiles/me');

export const updateCalculationProfile = (calculationSettings: Partial<CalculationSettings>) =>
  put(PUT_CALCULATION_PROFILE, calculationSettings, 'api', '/calculations/v1/profiles/me');
